import _extends from "@babel/runtime-corejs3/helpers/extends";import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";var _excluded = ["children", "width", "height", "color", "className", "viewBox"];import React from 'react';


var createIcon = function createIcon(props) {
  var children = props.children,width = props.width,height = props.height,_props$color = props.color,color = _props$color === void 0 ? 'currentColor' : _props$color,className = props.className,viewBox = props.viewBox,rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/(
    React.createElement("svg", _extends({
      width: width,
      height: height,
      fill: color,
      xmlns: "http://www.w3.org/2000/svg",
      className: className,
      viewBox: "".concat(viewBox || '0 0 24 24') },
    rest),

    children));


};

export default createIcon;
//# sourceMappingURL=createSVGIcon.js.map